import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/company-admin/page-vol-events';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: false,
  volEventIds: [],
  pagination: null,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, action) => {
    return {...state,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, action) => {
    const volEvents = _.get(action, 'result[1].volEvents');
    const pagination = _.get(action, 'result[1].pagination');
    return {...state,
      loadPending: false,
      volEventIds: volEvents.map(ve => ve.id),
      pagination,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
